import React, { useState, useEffect } from 'react';
import { useQuery } from '@common/hooks';
import {
  ACTIVE_SYSTEM_MESSAGE_BANNERS_QUERY,
  ActiveSystemMessageBannersQueryResponse,
} from '@common/graphql';
import { SystemMessageBanner } from './_system-message-banner';

const STORAGE_KEY_PREFIX = 'wk-dismissed-banner:';

const isDismissed = (id: string): boolean =>
  sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${id}`) === '1';

const dismiss = (id: string): void =>
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${id}`, '1');

export const SystemMessageBannerContainer = ({
  onVisibilityChange,
}: {
  onVisibilityChange: (visible: boolean) => void;
}) => {
  const { data } = useQuery<ActiveSystemMessageBannersQueryResponse>(
    ACTIVE_SYSTEM_MESSAGE_BANNERS_QUERY
  );
  const [dismissed, setDismissed] = useState(false);

  const banner = (data?.activeSystemMessageBanners ?? []).find(
    (b) => !isDismissed(b.id)
  );
  const isVisible = !!banner && !dismissed;

  useEffect(() => {
    onVisibilityChange(isVisible);
  }, [isVisible, onVisibilityChange]);

  const handleDismiss = (id: string) => {
    dismiss(id);
    setDismissed(true);
  };

  if (!banner || dismissed) return null;

  return (
    <SystemMessageBanner
      id={banner.id}
      body={banner.body}
      onDismiss={handleDismiss}
    />
  );
};
